import React, { useEffect } from "react";
import MapView from "./MapView";
import Navbar from "./Navbar";

function ScoutSites() {
  useEffect(() => {
    const url = "/api/authorize";
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        // check if data is {}
        if (Object.keys(data).length != 0) {
          window.location.href = "/login";
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, []);
  return (
    <div>
      <Navbar />
      <MapView />
    </div>
  );
}

export default ScoutSites;
